<template>
  <nav :class="['main-menu', { 'main-menu--mobile': isMobile }]">
    <div class="main-menu__item">
      <router-link :to="{
        name: 'UserProfile',
        params: { link: currentUserLink },
      }" class="main-menu__link">
        <el-icon v-if="!isMobile" class="main-menu__item-icon">
          <House />
        </el-icon>
        My profile
      </router-link>
    </div>

    <div class="main-menu__item">
      <router-link :to="{ name: 'Teams' }" class="main-menu__link">
        <el-icon v-if="!isMobile" class="main-menu__item-icon">
          <Ship />
        </el-icon>
        My teams
      </router-link>
    </div>

    <div class="main-menu__item">
      <router-link :to="{ name: 'Events' }" class="main-menu__link">
        <el-icon v-if="!isMobile" class="main-menu__item-icon">
          <Compass />
        </el-icon>
        My events
      </router-link>
    </div>

    <div class="main-menu__item">
      <router-link :to="{ name: 'Messages' }" class="main-menu__link">
        <el-icon v-if="!isMobile" class="main-menu__item-icon">
          <ChatSquare />
        </el-icon>
        My messages
      </router-link>
    </div>

    <div class="main-menu__item">
      <router-link :to="{ name: 'Applications' }" class="main-menu__link">
        <el-icon v-if="!isMobile" class="main-menu__item-icon">
          <Tickets />
        </el-icon>
        My applications
      </router-link>
    </div>

    <div class="main-menu__item">
      <router-link :to="{ name: 'Invitations' }" class="main-menu__link">
        <el-icon v-if="!isMobile" class="main-menu__item-icon">
          <DocumentChecked />
        </el-icon>
        My invitations
      </router-link>
    </div>

    <div class="main-menu__item">
      <router-link :to="{ name: 'Connections' }" class="main-menu__link">
        <el-icon v-if="!isMobile" class="main-menu__item-icon">
          <User />
        </el-icon>
        My connections
      </router-link>
    </div>

    <div class="main-menu__item">
      <router-link :to="{ name: 'Search' }" class="main-menu__link">
        <el-icon v-if="!isMobile" class="main-menu__item-icon">
          <Search />
        </el-icon>
        Search
      </router-link>
    </div>

    <div class="main-menu__item" v-if="isCurrentUserAdmin">
      <router-link :to="{ name: 'RegistrationRequests' }" class="main-menu__link">
        <el-icon v-if="!isMobile" class="main-menu__item-icon">
          <Bottom />
        </el-icon>
        Registration requests
      </router-link>
    </div>
  </nav>
</template>

<script setup>

defineProps({
  isMobile: {
    type: Boolean,
    required: false,
  },
});

import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const currentUser = computed(() => store.state.user);
const currentUserLink = computed(() => {
  return currentUser.value.userContactInfo
    ? currentUser.value.userContactInfo.link
    : null;
});
const isCurrentUserAdmin = computed(() => {
  const userRole = store.state.user.role;
  return userRole ? userRole === 'Admin' || userRole.includes('Admin') : false;
});
</script>

<style lang="scss" scoped>
@import '~@/styles/shared/_globals.scss';

.main-menu {
  margin-left: var(--global-dimension-size-200);
  top: calc(var(--global-dimension-size-400) + var(--header-height--mobile));
  position: sticky;

  @include from('xl') {
    top: calc(var(--global-dimension-size-400) + var(--header-height));
  }

  &--mobile {
    margin-left: 0;
    position: static;
    top: 0;
  }

  &__item-icon {
    margin-right: var(--global-dimension-size-125);
  }

  &__link {
    display: inline-block;
    padding: var(--global-dimension-size-75) 0 var(--global-dimension-size-150);

    color: var(--color-gray-900);
    font-size: var(--font-size-200);

    &:hover {
      color: var(--color-primary-400);
    }

    &.router-link-active {
      color: var(--color-primary-400);
    }
  }
}
</style>
